export const GAMESTATE = {
    INIT: 0,
    RUNNING: 1,
    MENU: 2,
    POURED  : 3,
    MISSED: 4,
    WON: 5,
    SPILLED: 6,
    CONGRATS: 7,
    GAMEOVER: 8
}
